import React from 'react';
import { Link } from 'react-router-dom';
import { brandBlue, textDark, background } from '../styles/theme';

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center" style={{ background: background, minHeight: '80vh' }}>
      <div className="text-center px-6 max-w-2xl">
        {/* 4 [Logo] 4 Layout */}
        <div className="flex items-center justify-center mb-8">
          <span className="text-9xl md:text-[12rem] font-bold" style={{ color: brandBlue }}>4</span>
          <img 
            src="/BBM-Logo_animate.svg" 
            alt="BIG BLUE MARBLE logo" 
            className="md:h-48 h-24 w-auto"
          />
          <span className="text-9xl md:text-[12rem] font-bold" style={{ color: brandBlue }}>4</span>
        </div>
        
        {/* Page Not Found Message */}
        <h1 className="text-2xl md:text-3xl font-semibold mb-4" style={{ color: textDark }}>
          Page Not Found
        </h1>
        
        
        <p className="text-lg mb-8" style={{ color: textDark, opacity: 0.8 }}>
          Sorry, the page you're looking for doesn't exist or has been moved.
        </p>
        
        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link 
            to="/"
            className="px-8 py-3 rounded-lg font-medium transition-all duration-300 hover:scale-105 hover:shadow-lg"
            style={{ 
              background: brandBlue, 
              color: 'white', 
              textDecoration: 'none',
              boxShadow: '0 4px 12px rgba(23, 66, 140, 0.3)'
            }}
          >
            Go Home
          </Link>
          
          <button 
            onClick={() => window.history.back()}
            className="px-8 py-3 rounded-lg font-medium border-2 transition-all duration-300 hover:scale-105"
            style={{ 
              borderColor: brandBlue, 
              color: brandBlue, 
              background: 'transparent'
            }}
          >
            Go Back
          </button>
        </div>
        
        {/* Additional Help Text */}
        <div className="mt-12 text-sm" style={{ color: textDark, opacity: 0.6 }}>
          <p>If you believe this is an error, please contact our support team.</p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
